<template>
  <div>
    <div class="filter-wrap">
      <div style="width: 26%;">
        <v-datetime-picker
          v-model="dateFrom"
          color="accent"
          label="Выберите дату от"
        />
      </div>

      <div style="width: 26%;">
        <v-datetime-picker
          v-model="dateTo"
          color="accent"
          label="Выберите дату до"
        />
      </div>

      <div style="width: 26%;">
        <v-select
          v-model="currentStatusFilter"
          :items="dropdownStatusItems"
          color="accent"
          label="Статус"
          item-title="title"
        >
          <template #selection="{ item }">
            {{ item.title }}
          </template>

          <template #item="{ item }">
            {{ item.title }}
          </template>
        </v-select>
      </div>

      <v-btn :disabled="isDisabled" color="primary" @click="refreshTrustPoint">Проверить баланс</v-btn>
    </div>

    <paginated-table
      ref="paginatedTable"
      :items="items"
      :headers="headers"
      :loading="loading"
      :pullFunction="getTrustPoints"
      :pagination.sync="pagination"
    >
      <template #items="props">
        <UserTrustPointsItem :item="props.item" />
      </template>
    </paginated-table>

    <v-snackbar v-model="checkTrustPoint" color="green">
      <p style="margin: 0 auto">Идет проверка баланса</p>
    </v-snackbar>
  </div>
</template>

<script>
import PaginatedTable from '@/components/PaginatedTable.vue'
import UserTrustPointsItem from '@/components/common/Table/UserTrustPointsTable/UserTrustPointsItem.vue'
import { checkTrustPoints, getTrustPointsInUser } from '../../../../../api/trust'
import VueMixin from '@/components/VueMixin.vue'
import User from '../../../../../helpers/user'

export default {
  name: 'UserTrustPointsTable',
  components: { PaginatedTable, UserTrustPointsItem },
  mixins: [VueMixin],
  data () {
    return {
      isDisabled: false,
      checkTrustPoint: false,
      dateTo: null,
      dateFrom: null,
      page: 1,
      pagination: {
        sortBy: 'created_at:desc',
        descending: true
      },
      loading: true,
      currentStatusFilter: null,
      dropdownStatusItems: [
        {
          title: 'Все',
          value: null
        },
        {
          title: 'Отказано',
          value: '1'
        },
        {
          title: 'Принято',
          value: '2'
        },
        {
          title: 'В процессе',
          value: '0'
        }
      ],
      headers: [
        {
          text: 'Дата создания записи', value: 'created_at', sortable: true
        },
        {
          text: 'Расчетный баланс', value: 'trust_balance', sortable: false
        },
        {
          text: 'Баланс', value: 'balance', sortable: false
        },
        {
          text: 'Разница', value: 'difference', sortable: true
        },
        {
          text: 'Статус', value: 'status', sortable: false
        }
      ],
      items: []
    }
  },
  computed: {
    User () {
      return User
    }
  },
  watch: {
    dateFrom () {
      this.getTrustPoints(1)
    },
    dateTo () {
      this.getTrustPoints(1)
    },
    currentStatusFilter () {
      this.getTrustPoints(1)
    },
    pagination: {
      handler (newPagination) {
        if (newPagination.sortBy === 'created_at' || newPagination.sortBy === 'difference')
          this.getTrustPoints(1)
      },
      deep: true
    }
  },
  created () {
    this.getTrustPoints(1)
  },
  mounted () {
    EventBus.$on('update-user-trust_point-table', () => this.getTrustPoints(1))
  },
  beforeDestroy () {
    EventBus.$off('update-user-trust_point-table')
  },
  methods: {
    getTrustPoints (page) {
      this.page = page
      let sortParam = 'created_at:desc'
      if (this.pagination.sortBy === 'created_at' || this.pagination.sortBy === 'difference') {
        const sortOrder = this.pagination.descending ? 'desc' : 'asc'
        sortParam = `${this.pagination.sortBy}:${sortOrder}`
      }

      getTrustPointsInUser({
        limit: 26,
        offset: (page - 1) * 25,
        user_id: this.$route.params.user,
        sort: sortParam,
        date_from: this.dateFrom ? this.formatDateFilter(this.dateFrom) : undefined,
        date_to: this.dateTo ? this.formatDateFilter(this.dateTo) : undefined,
        status: this.currentStatusFilter
      }).then(response => {
        this.items = response.data
        this.loading = false
        this.isDisabled = false
      })
    },
    refreshTrustPoint () {
      this.isDisabled = true
      this.checkTrustPoint = true
      checkTrustPoints(this.$route.params.user)
    }
  }
}
</script>

<style scoped>
.filter-wrap {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;

  p {
    margin: 0;
  }
  .filter {
    width: 30%;
  }
}
</style>
